export default "__VITE_ASSET__CPWF5DRV__"